import { T } from '../../styles/tokens';
/**
 * SkillBadge — Shared badge component for skill tier/verification status
 * Used across: OpenClawSkills, ReinstallMachineModal, CreateAgentModal, SkillsCenterPage
 */

interface Props {
  tier?: string;
  verified?: number | boolean;
  badge?: string;
  size?: 'sm' | 'md';
  verifiedAt?: string;
}

const BADGE_CONFIGS: Record<string, { text: string; bg: string; color: string; border: string }> = {
 verified: { text: 'Verificada', bg: T.successBg, color: T.success, border: T.successBg },
 recommended: { text: 'Recomendada', bg: T.warningBg, color: T.warning, border: T.warningBg },
 community: { text: 'Comunidade', bg: T.primaryBg, color: T.primary, border: T.primaryBg },
  new: { text: '🆕 Nova', bg: T.dangerBg, color: T.danger, border: T.dangerBg },
};

export function getBadgeType(tier?: string, verified?: number | boolean, badge?: string): string {
  if (badge && BADGE_CONFIGS[badge]) return badge;
  if (tier === 'tier1' || verified) return 'verified';
  if (tier === 'tier2') return 'recommended';
  return 'community';
}

function isRecentlyAdded(verifiedAt?: string): boolean {
  if (!verifiedAt) return false;
  try {
    const diff = Date.now() - new Date(verifiedAt).getTime();
    return diff < 7 * 24 * 60 * 60 * 1000; // 7 days
  } catch { return false; }
}

export function SkillBadge({ tier, verified, badge, size = 'sm', verifiedAt }: Props) {
  const type = getBadgeType(tier, verified, badge);
  const config = (BADGE_CONFIGS[type] || BADGE_CONFIGS['community'])!;
  const fontSize = size === 'sm' ? '9px' : '11px';
  const padding = size === 'sm' ? '2px 6px' : '3px 8px';
  const isNew = isRecentlyAdded(verifiedAt);

  return (
    <span
      role="status"
      aria-label={`Skill ${config.text}`}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '3px',
        padding, borderRadius: '12px', fontSize, fontWeight: 700,
        background: config.bg, color: config.color,
        border: `1px solid ${config.border}`,
        lineHeight: 1.2, whiteSpace: 'nowrap', flexShrink: 0,
        animation: isNew ? 'skillPulse 2s ease-in-out infinite' : undefined,
      }}
    >
      {config.text}
    </span>
  );
}

export function ApiKeyIndicator({ requiresApiKey, requiredKeys, size = 'sm' }: { requiresApiKey?: boolean | number; requiredKeys?: string; size?: 'sm' | 'md' }) {
  const fontSize = size === 'sm' ? '9px' : '11px';
  if (requiresApiKey) {
    return (
      <span style={{ fontSize, color: T.warning, display: 'inline-flex', alignItems: 'center', gap: '3px' }}>
 {requiredKeys || 'API Key'}
      </span>
    );
  }
  return (
 <span style={{ fontSize, color: T.success }}>Sem API Key</span>
  );
}
